<article class="tile" [attr.data-tier]="vm?.tier">
  <p class="tile__title">{{ vm?.title }}</p>
  <p class="tile__value">{{ vm?.valueLabel }}</p>
  <p class="tile__change" *ngIf="vm?.changeLabel">{{ vm.changeLabel }}</p>
</article>
